<template>
    <div v-html="safeHtml" :style="getHtmlStyle(data?.style)"></div>
  </template>
  
  <script>
  import DOMPurify from 'dompurify';
  
  export default {
    name: 'HtmlBlock',
    props: {
      data: Object,
    },
    computed: {
    safeHtml() {
      // cleans content for safety reasons
      return DOMPurify.sanitize(this.data?.props?.contents, {ADD_ATTR: ['target', 'rel']});
    }},
    methods: {
      getHtmlStyle(style) {
        const fontFamilyMapping = {
          BOOK_SANS: 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif',
          ORGANIC_SANS: 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif',
          GEOMETRIC_SANS: 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif',
          HEAVY_SANS: 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif',
          ROUNDED_SANS: 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif',
          MODERN_SERIF: 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif',
          BOOK_SERIF: '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif',
          MONOSPACE: '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace',
          MODERN_SANS: '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif',
          SIMPLE: 'Arial',
          DEFAULT: 'inherit'
        };
        const fontFamily = fontFamilyMapping[style?.fontFamily] || fontFamilyMapping.DEFAULT;
        const defaultTextAlign = 'left';
        const defaultFontSize = '16px';
        const padding = style?.padding || { top: 0, bottom: 0, left: 0, right: 0 };
        return {
          color: style?.color || null,
          backgroundColor: style?.backgroundColor || null,
          fontWeight: style?.fontWeight || 'normal',
          textAlign: style?.textAlign || defaultTextAlign,
          fontSize: style?.fontSize ? `${style.fontSize}px` : defaultFontSize,
          fontFamily: fontFamily,
          padding: `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`,
        };
      },
    },
  };
  </script>
  
  <style scoped>
  .component {
    position: relative;
  }
  .component:hover {
    border: 1px solid #05bbef;
  }
  .component:active {
    border: 1px solid darkblue;
  }
  </style>
  